var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "select",
      {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selected,
            expression: "selected",
          },
        ],
        staticClass: "select-dropdown",
        attrs: { tabindex: _vm.tabindex },
        on: {
          change: [
            function ($event) {
              var $$selectedVal = Array.prototype.filter
                .call($event.target.options, function (o) {
                  return o.selected
                })
                .map(function (o) {
                  var val = "_value" in o ? o._value : o.value
                  return val
                })
              _vm.selected = $event.target.multiple
                ? $$selectedVal
                : $$selectedVal[0]
            },
            function ($event) {
              return _vm.onChange()
            },
          ],
        },
      },
      _vm._l(_vm.options, function (option, i) {
        return _c("option", { key: i, domProps: { value: option } }, [
          _vm._v(
            " " +
              _vm._s(_vm.displayKey !== "" ? option[_vm.displayKey] : option) +
              " "
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }